<template>
    <v-container fluid>
        <v-snackbar v-model="snackbar.show" top right>
            {{ snackbar.text }}
            <v-btn color="pink" text @click="snackbar.show = false">
                Закрыть
            </v-btn>
        </v-snackbar>
        <v-card>
            <v-toolbar color="purple darken-3">
                <h3 class="white--text">{{ report.periodStart | dateShow }} - {{ report.periodEnd | dateShow }}</h3>
                <v-spacer></v-spacer>
                <v-btn text dark @click.stop="showBasicDataDialog">Показатели
                    <v-icon class="ml-2" small dark>mdi-database</v-icon>
                </v-btn>
            </v-toolbar>
            <v-row>
                <v-col cols="12">
                    <v-content class="pt-0 pl-4 pr-4 pb-0">
                        <v-tabs v-model="tab" background-color="deep-purple accent-4"
                                center-active
                                dark>
                            <v-tab href="#1">Основные</v-tab>
                            <v-tab href="#2">Загрузка</v-tab>
                            <v-tab href="#3">Клиенты</v-tab>
                            <v-tab href="#4">KPI</v-tab>
                            <v-tab href="#5">Масло ДВС</v-tab>
                            <v-tab href="#6">Закуп</v-tab>
                            <v-tab href="#7">Реестр ЗН</v-tab>
                            <v-tab href="#8">Штат</v-tab>
                            <v-tab href="#9">Акции</v-tab>
                            <v-tab href="#10">Обратная связь</v-tab>
                            <v-tab href="#11">Задачи</v-tab>
                            <v-tab href="#12">Файлы и ссылки</v-tab>
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab-item value="1">
                                <main-tab v-if="mode !== null" :key="reportKey + 100" v-model="report" @change="updateReport" :mode="mode"></main-tab>
                            </v-tab-item>
                            <v-tab-item value="2">
                                <load-tab v-if="mode !== null" v-model="report" @change="updateReport" :mode="mode"></load-tab>
                            </v-tab-item>
                            <v-tab-item value="3">
                                <client-tab v-if="mode !== null" v-model="report" @change="updateReport" :mode="mode"></client-tab>
                            </v-tab-item>
                            <v-tab-item value="4">
                                <kpi-tab v-if="mode !== null" v-model="report" @change="updateReport" :mode="mode"></kpi-tab>
                            </v-tab-item>
                            <v-tab-item value="5">
                                <oil-tab v-model="report" @change="updateReport" :mode="mode"></oil-tab>
                            </v-tab-item>
                            <v-tab-item value="6">
                                <purchase-tab v-model="report" @change="updateReport" @reloadreport="getReport" :mode="mode"></purchase-tab>
                            </v-tab-item>
                            <v-tab-item value="7">
                                <orders-register-tab v-model="report" @change="updateReport" :mode="mode"></orders-register-tab>
                            </v-tab-item>
                            <v-tab-item value="8">
                                <state-tab v-model="report" @change="updateReport" :mode="mode"></state-tab>
                            </v-tab-item>
                            <v-tab-item value="9">
                                <campaign-tab v-model="report" :mode="mode" @change="updateReport"></campaign-tab>
                            </v-tab-item>
                            <v-tab-item value="10"><feedback-tab v-model="report" @change="updateReport" :mode="mode"></feedback-tab> </v-tab-item>
                            <v-tab-item value="11">
                                <tasks-tab v-model="report" :mode="mode" @change="updateReport"></tasks-tab>
                            </v-tab-item>
                            <v-tab-item value="12">
                                <files-tab v-model="report" @change="updateReport" :mode="mode"></files-tab>
                            </v-tab-item>
                        </v-tabs>
                    </v-content>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-header>JSON-отчет</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <code :key="reportKey">{{ report }}</code>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-card>

        <basic-data-dialog v-if="report.basic && !!dialogs.basic.show" :mode="mode" v-model="report" @reloaddata="reloadCalculatedData" @change="reloadCalculatedData" :show="dialogs.basic.show"></basic-data-dialog>

    </v-container>
</template>
<script>
  import moment from 'moment'
  import BasicDataDialog from '../components/skypesaccounts/basicDataDialog'
  import MainTab from '../components/skypesaccounts/mainTab'
  import LoadTab from '../components/skypesaccounts/loadTab'
  import ClientTab from '../components/skypesaccounts/clientTab'
  import KpiTab from '../components/skypesaccounts/kpiTab'
  import OilTab from '../components/skypesaccounts/oilTab'
  import OrdersRegisterTab from '../components/skypesaccounts/ordersRegisterTab'
  import PurchaseTab from '../components/skypesaccounts/purchaseTab'
  import StateTab from '../components/skypesaccounts/stateTab'
  import FeedbackTab from '../components/skypesaccounts/feedbackTab'
  import FilesTab from '../components/skypesaccounts/filesTab'
  import TasksTab from '../components/skypesaccounts/tasksTab'
  import CampaignTab from '../components/skypesaccounts/campaignTab'

  export default {
    components: { CampaignTab, TasksTab, FilesTab, FeedbackTab, StateTab, PurchaseTab, OrdersRegisterTab, OilTab, KpiTab, ClientTab, LoadTab, MainTab, BasicDataDialog },
    data: () => ({
      snackbar: {
        text: 'Отчет обновлен! Перезагрузите страницу!',
        show: false
      },
      mainError: null,
      loadRatio: {
        1: 0.62,
        2: 0.66,
        3: 0.82,
        4: 1,
        5: 0.99,
        6: 0.9,
        7: 0.88,
        8: 0.89,
        9: 0.84,
        10: 0.95,
        11: 0.9,
        12: 0.68
      },
      dialogs: {
        basic: {
          show: false,
        }
      },
      tab: null,
      reportKey: 0,
      mode: 'franch',
      report: {
        economic: {
          proceeds: 1000000,
          workingHours: 1000
        },
        data: {
          pastDays: 1,
          daysInMonth: 30,
          load: 0.9,
          workPlaces: 3
        },
        meta: {
          month: 1,
          year: 2019,
          lastYear: 2018
        },
        periodStart: null,
        periodEnd: null,
        dealID: null,
        indicatorSTO: {
          current: {},
          last: {},
        },
        rating: {
          current: {
            masters: [],
          },
          last: {
            masters: [],
          },
        },
        purchase: {},
        campaign: {
          final: {},
          campaignOrders: {
            old: {},
            new: {},
            many: 0
          },
          reOrders: {},
        },

      },
    }),
    watch: {},
    computed: {},
    filters: {
      dateShow (value) {
        if (value !== null) return moment(value, 'DD.MM.YYYY').format('DD.MM.YYYY')
        return 'loading'
      }
    },
    methods: {
      showBasicDataDialog () {
        this.dialogs.basic.show = true
        console.log('basic dialog', this.dialogs.basic.show)
      },
      getBasicData: async function () {
          try {
            const r = await this.$http.get(`${this.$store.getters.api}v3/accounts/basic/last`)
            if(!this.report.basic) this.report.basic = r.data.data
            this.reportKey += 3
            console.log('basic', this.report.basic)
            //this.updateReport()
          } catch (e) {
            console.log(e)
          }
      },
      reloadCalculatedData() {
        this.dialogs.basic.show = false
        //this.calculateData()
      },

      async getReport (woSocket = false) {
        //v3/accounts/report/:dealid
        this.mode = null
        try {
          const r = await this.$http.get(`${this.$store.getters.api}v3/accounts/report/${this.$route.params.dealid}`)
          console.log('data', r.data)
          if (!r.data.error) {
            this.report = JSON.parse(JSON.stringify(r.data))
            await this.getBasicData()
            this.updateReport(woSocket)
            this.mode = 'franch'
          } else {
            this.mainError = 'Отчет не найден'
          }
        } catch (e) {
          console.log(e)
        }
      },
      async updateReport (woSocket = false) {
        this.dialogs.basic.show = false
        console.log('ОТЧЕТ', this.report)
        console.log('dealid', this.$route.params.dealid)
        try {
          const r = await this.$http.post(`${this.$store.getters.api}v3/accounts/report/${this.$route.params.dealid}`, {
            report: JSON.stringify(this.report)
          })
          console.log('update', r.data)
        } catch (e) {
          console.log('report save error', e)
        }
      },
    },
    created () {
      this.$emit('maincomponenthooks', { hideAppBar: true })
    },
    async mounted () {

      await this.getReport(true)

    },
  }
</script>
<style>

</style>
